import { useFeature } from '@mafc/appshell';
import { useState } from 'react';
import { IAddress } from 'services/user/types/user.types';

const useEmirateAddress = (selectedAddress: IAddress) => {
  const [isOpen, setOpen] = useState(false);

  const isEmirateEnabled = useFeature('address_emirate').on;

  const addressHasEmirateField = !!(selectedAddress && selectedAddress.emirate);

  const openEmiratePopup = () => setOpen(true);

  const closeEmiratePopup = () => setOpen(false);

  return {
    addressHasEmirateField,
    isEmiratePopupOpen: isOpen,
    isEmirateEnabled,
    openEmiratePopup,
    closeEmiratePopup,
  };
};

export default useEmirateAddress;
